/**
 * This is a fairly generic module that let's you easily create and manage a multiselect
 *
 * @author Manoj Kintali (mkintali@yext.com)
 */

goog.provide('yext.ui.MultiSelect');
goog.provide('yext.ui.MultiSelect.Option');
goog.provide('yext.ui.MultiSelect.OptionView');

goog.require('yext');
goog.require('yext.mvc.Collection');
goog.require('yext.mvc.Model');
goog.require('yext.mvc.View');

/**
 * Constructor for the MultiSelect module.
 * @param {boolean=}    showSelectAll   Whether to show a "Select all" button
 * @constructor
 */
yext.ui.MultiSelect = function(opt) {
  yext.mvc.View.call(this);

  /**
   * @type {!jQuery}
   */
  this.$el = $('<div/>');

  /**
   * @type {boolean}
   */
  this.showSelectAll = opt.showSelectAll || false;

  /**
   * @type {function()}
   */
  this.selectAllCallback = opt.selectAllCallback || function() {};

  /**
   * @type {yext.mvc.Collection}
   */
  this._options = new yext.mvc.Collection(yext.ui.MultiSelect.Option);
};
goog.inherits(yext.ui.MultiSelect, yext.mvc.View);

/**
 * Intializes the MultiSelect view.
 *
 * @param {!Array.<yext.ui.MultiSelect.Option>}   options  List of options to initialize with
 */
yext.ui.MultiSelect.prototype.init = function(options) {
  this._options = new yext.mvc.Collection(yext.ui.MultiSelect.Option);
  this.bindRenderToModel();
  this._options.init(options);
  this.bindCheckOption();
  if (this.showSelectAll) {
    this.bindSelectAll();
  }
  return this;
};

/**
 * Binds the update event on the _options collection so the view re-renders each time
 * an option is added/removed from the _options collection.
 */
yext.ui.MultiSelect.prototype.bindRenderToModel = function() {
  this._options.on('update,change', this.render.bind(this));
};

yext.ui.MultiSelect.prototype.bindSelectAll = function() {
  var self = this;
  $(document).off('click', '.js-deselect-all-fields').on('click', '.js-deselect-all-fields', function() {
    self._options.each(function(option) {
      option.set('checked', false);
    });
    self.selectAllCallback();
  });
};

/**
 * Adds an option to this MultiSelect module.
 *
 * @param {yext.ui.MultiSelect.Option} option   The option you want to add
 */
yext.ui.MultiSelect.prototype.addOption = function(option) {
  if (!(option instanceof yext.ui.MultiSelect.Option)) {
    throw new TypeError(
      'yext.ui.MultiSelect.Option: Invalid option type provided');
  }
  this._options.add(option);
};

/**
 * Renders the html for this MultiSelect module.
 *
 * @returns {string} the html fo this module.
 */
yext.ui.MultiSelect.prototype.render = function() {
  var self = this;
  this.$el.empty();
  if (this._options && this.showSelectAll) {
    this.$el.append('<a class="js-deselect-all-fields">' + yext.msg('Deselect All Fields') + '</a>');
  }
  this._options.each(function(option) {
    var optionView = new yext.ui.MultiSelect.OptionView(option);
    self.$el.append(optionView.$el);
  });
};

/**
 * Goes through all the options to see which ones are checked.
 *
 * @return {!Array.<yext.ui.MultiSelect.Option>}  The checked options
 */
yext.ui.MultiSelect.prototype.getCheckedOptions = function() {
  var checkedOptions = [];
  this._options.each(function(option) {
    if (option.checked) {
      checkedOptions.push(option);
    }
  });
  return checkedOptions;
};

/**
 * Checks if all the options are checked
 *
 * @return {boolean} True if all options are checked, false otherwise
 */
yext.ui.MultiSelect.prototype.isAllOptionsChecked = function() {
  return this.getCheckedOptions().length === this._options.length();
};

yext.ui.MultiSelect.prototype.bindCheckOption = function() {
  var self = this;
  $(document).off('change', '.js-multiselect-option').on('change', '.js-multiselect-option', function(e) {
    self._options.getById(e.target.id).setChecked($(this).find(':checkbox')[0].checked);
    $(self).trigger('option.changed');
  });
};


/**
 * @param {string}       id                      The id of the option.
 * @param {string}       label                   The label to be displayed for the option
 * @param {boolean=}     opt_checked             Whether this option should be checked by default
 * @param {string}       opt_additional_html    Additional html to append to the label text
 * @constructor
 */
yext.ui.MultiSelect.Option = function(id, label, opt_checked, opt_additional_html) {
  this.id = id;
  this.label = label;
  this.checked = opt_checked || false;
  this.additionalHtml = opt_additional_html;
};
goog.inherits(yext.ui.MultiSelect.Option, yext.mvc.Model);

/**
 * Sets the checked value of this option.
 * @param {boolean}   checked     The checked value.
 */
yext.ui.MultiSelect.Option.prototype.setChecked = function(checked) {
  this.checked = checked;
};

/**
 * Constructor for the OptionView object. This view model will know how to render an option
 *
 * @param {yext.ui.MultiSelect.Option}    option  The option model that this view represents
 * @constructor
 */
yext.ui.MultiSelect.OptionView = function(option) {
  yext.mvc.View.call(this);
  if (!(option instanceof yext.ui.MultiSelect.Option)) {
    throw new TypeError(
      'yext.ui.MultiSelect.Option: Invalid option type provided');
  }
  this.option = option;

  this.$el = $('<div class="js-multiselect-option multiselect-option"><input type="checkbox"><label></label></div>');
  this.$input = this.$el.find('input');
  this.$label = this.$el.find('label');
  if (this.option.additionalHtml) {
    this.$el.append(this.option.additionalHtml);
  }

  this.render();
};
goog.inherits(yext.ui.MultiSelect.OptionView, yext.mvc.View);

/**
 * Generates the html for this one option.
 *
 * @returns {string} the html for this option.
 */
yext.ui.MultiSelect.OptionView.prototype.render = function() {
  this.$input.attr('id', this.option.id);
  this.$input.attr('checked', this.option.checked);

  this.$label.attr('for', this.option.id);
  this.$label.text(this.option.label);
};
